import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PaymentRouter } from './pages/PaymentRouter';
import { AmountPage } from './pages/AmountPage';
import { WalletPage } from './pages/WalletPage';
import { AuthPage } from './pages/AuthPage';
import { KycPage } from './pages/KycPage';
import { ReviewPage } from './pages/ReviewPage';
import { InstructionsPage } from './pages/InstructionsPage';
import { StatusPage } from './pages/StatusPage';
import { FastTrackPage } from './pages/FastTrackPage';
import { NotFoundPage } from './pages/NotFoundPage';

function App() {
  return (
    <BrowserRouter>
      <PaymentRouter>
        <Routes>
          {/* Payment flow pages */}
          <Route path="/pay" element={<AmountPage />} />
          <Route path="/pay/wallet" element={<WalletPage />} />
          <Route path="/pay/auth" element={<AuthPage />} />
          <Route path="/pay/kyc" element={<KycPage />} />
          <Route path="/pay/review" element={<ReviewPage />} />
          <Route path="/pay/instructions" element={<InstructionsPage />} />
          <Route path="/pay/status" element={<StatusPage />} />
          <Route path="/pay/fast-track" element={<FastTrackPage />} />

          {/* 404 page */}
          <Route path="/404" element={<NotFoundPage />} />

          {/* Redirect root to 404 if no params */}
          <Route path="/" element={<Navigate to="/404" replace />} />

          {/* Catch all - redirect to 404 */}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </PaymentRouter>
    </BrowserRouter>
  );
}

export default App;
